import { recruiting } from "@/api/analytics/analytics.recruiting.api.ts";
import { analyticsTimeOffApi } from "@/api/analytics/analytics.time-off.api.ts";

export const apiAnalytics = {
  recruiting: recruiting,
  timeOff: analyticsTimeOffApi,
};
